import * as React from "react";
import axios from "axios";
import IMyCompaniesPage from "./IMyCompaniesPage";
import CompaniesListData from "@appComponents/CompaniesListData/CompaniesListData";
import BttfAxios from "@features/utils/axios";
import Loader from "@appComponents/Loader/Loader";
import { ICompanyItem } from "@company/components/CompaniesList/ICompaniesList";
import { classNames } from "@features/utils/reactFunctions";
import Header from "@appComponents/Header/Header";

import * as style from "./MyCompaniesPageStyle.module.scss";
import * as general from "@appStyles/general.module.scss";

type TMyCompaniesPage = {
  companiesList: ICompanyItem[];
  dataLoaded: boolean;
  total: number;
  isOrganizational: boolean;
};

export default class MyCompaniesPage extends React.Component<
  IMyCompaniesPage,
  TMyCompaniesPage
> {
  state = {
    companiesList: [],
    dataLoaded: false,
    total: 0,
    isOrganizational: false,
  };

  componentDidMount() {
    BttfAxios.all(
      [
        axios.get(`/api/profiles/${this.props.slug}/companies`),
        axios.get(`/api/users/me`),
      ],
      (companies, me) => {
        this.setState({
          companiesList: companies.data,
          total: companies.data.length,
          dataLoaded: true,
          isOrganizational: me.data.organizational,
        });
      }
    );
  }

  render() {
    const { companiesList, total, isOrganizational } = this.state;
    return (
      <React.Fragment>
        <Header padding={"0 20"}>
          <div className={classNames(general.profileHeaderWrapper)} />
        </Header>
        <div
          className={classNames(
            style.companiesContainer,
            style.companiesContainerNegativeMargin,
            style.companiesContainerFfMargin
          )}
        >
          {companiesList.length === 0 && !this.state.dataLoaded && <Loader />}

          {companiesList.length > 0 && (
            <>
              <div
                className={[style.clearfix, style.companiesCountContainer].join(
                  " "
                )}
              >
                <div className={style.companiesCount} data-cy="companies-count">
                  {`${total} Companies`}
                </div>
              </div>
              <CompaniesListData
                companiesList={companiesList}
                profileId={this.props.profileId}
                connectedToRouter={false}
              />
            </>
          )}
          {companiesList.length === 0 && this.state.dataLoaded && (
            <>
              <h1 className={style.noResults} data-cy="no-companies">
                Apply for finance to create your first company
              </h1>
              <a
                className={classNames(
                  style.newCompanyLink,
                  style.newCompanyLinkEmpty
                )}
                href="/pitches/application/new"
                data-cy="add-new-company"
              >
                Apply for finance
              </a>
            </>
          )}
        </div>
      </React.Fragment>
    );
  }
}
